import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { downloadErrorHandler, errorHandler } from '../../../util/error.service'

export async function getFtpServers() {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotFtpServers)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveFtpServer(server) {
  try {
    const { data } = server.id
      ? await authHttp().put(routes.urlXmlRobotFtpServerById(server.id), server)
      : await authHttp().post(routes.urlXmlRobotFtpServer, server)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getFtpServerCompanies(ftpServerId) {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotFtpServerCompanies(ftpServerId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveFtpServerCompany(ftpServerId, { tp_id, company_id }) {
  try {
    const { data } = await authHttp().post(routes.urlXmlRobotFtpServerCompany(ftpServerId), {
      tp_id,
      company_id,
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteFtpServerCompany(id) {
  try {
    const { data } = await authHttp().delete(routes.urlDeleteXmlRobotFtpServerCompany(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getActiveTps() {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotActiveTps)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getActiveCompanies() {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotActiveCompanies)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Email Receivers
export async function getEmailReceivers() {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotEmailReceivers)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveEmailReceiver(receiver) {
  try {
    const { data } = receiver.id
      ? await authHttp().put(routes.urlXmlRobotEmailReceiverById(receiver.id), receiver)
      : await authHttp().post(routes.urlXmlRobotEmailReceiver, receiver)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEmailReceiverSenders(receiverId) {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotEmailReceiverSenders(receiverId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveEmailReceiverSender(receiverId, { tp_id, company_id, email_from }) {
  try {
    const { data } = await authHttp().post(routes.urlXmlRobotEmailReceiverSender(receiverId), {
      tp_id,
      company_id,
      email_from,
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteEmailSender(id) {
  try {
    const { data } = await authHttp().delete(routes.urlDeleteXmlRobotEmailSender(id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getXmlImportLogs(pInicial, pFinal) {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotImportLogs(pInicial, pFinal))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function downloadXmlImportLog(logId) {
  try {
    const { data } = await authHttp().get(routes.urlXmlRobotImportLogFile(logId), {
      responseType: 'blob',
    })
    return data
  } catch (error) {
    throw await downloadErrorHandler(error)
  }
}
